import { render, staticRenderFns } from "./SeatingRow.vue?vue&type=template&id=66516414&scoped=true&"
import script from "./SeatingRow.vue?vue&type=script&lang=js&"
export * from "./SeatingRow.vue?vue&type=script&lang=js&"
import style0 from "./SeatingRow.vue?vue&type=style&index=0&id=66516414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66516414",
  null
  
)

export default component.exports